export const TOUCH_DEVICE_MQ = '(hover: none) and (pointer: coarse)';

export const isTouchDevice = () => window.matchMedia(TOUCH_DEVICE_MQ).matches;
